import React, { useCallback } from "react";
import Fonts from "../../../Config/Fonts";
import Strings from "../../../Config/Strings";
import Colors from "../../../theme/Colors";

const CustomTable = ({ tableData, mainHeadingText, tableHeaderData }) => {
  const TableBodyComponent = useCallback(
    () => (
      <tbody>
        {tableData?.map((tableContent, index) => (
          <tr key={tableContent?.id}>
            <td
              style={
                index === tableData.length - 1
                  ? { ...tableDataInputStyle, borderBottom: "none" } // Remove bottom border for the last row
                  : tableDataInputStyle
              }
            >
              {index + 1}
            </td>
            <td
              style={
                index === tableData.length - 1
                  ? { ...tableDataInputStyle, borderBottom: "none" } // Remove bottom border for the last row
                  : tableDataInputStyle
              }
            >
              {tableContent?.brandName}
            </td>
          </tr>
        ))}
      </tbody>
    ),
    [tableData]
  );

  const TableHeaderComponent = useCallback(
    () => (
      <thead>
        {tableHeaderData?.map((tableContent, index) => (
          <th key={index} style={tableHeaderStyle}>
            {tableContent?.header}
          </th>
        ))}
      </thead>
    ),
    [tableHeaderData]
  );

  return (
    <div style={mainContainer}>
      <p style={mainHeadingTxt}>{mainHeadingText}</p>

      <div style={outerWrapper}>
        <div style={tableWrapper}>
          {tableData?.length === 0 ||
            tableData?.length === undefined ||
            tableData?.length === null ? (
            <div style={{marginTop: '40%'}}>
              <span style={noDataTextStyle}>{Strings.NoDataFound}</span>
            </div>
          ) : (
            <table style={table}>
              <TableHeaderComponent />
              <TableBodyComponent />
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

const mainContainer = {
  height: "50%",
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const mainHeadingTxt = {
  textAlign: "center",
  fontSize: 14,
  fontWeight: 600,
  fontFamily: Fonts.Poppins,
  color: Colors.white,
  backgroundColor: Colors.adminPrimaryColor,
  padding: "15px",
  margin: "0",
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const tableHeaderStyle = {
  fontSize: 12,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.breadCrumbsColor,
  position: "sticky",
  top: 0,
  textAlign: "center",
  padding: 3,
  paddingTop: "8px",
  borderBottom: "1px solid #ccc",
};

const noDataTextStyle = {
  fontSize: 13,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.breadCrumbsColor,
};

const outerWrapper = {
  borderRadius: "4px",
  width: "100%",
  height: "90%",
};

const table = {
  minWidth: "100%",
  borderCollapse: "separate",
  borderSpacing: "0px",
};

const tableDataInputStyle = {
  fontSize: 12,
  fontWeight: 500,
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  textAlign: "center",
  padding: "2px 2px",
  borderBottom: "1px solid #ccc",
};

const tableWrapper = {
  height: "75%",
  width: "100%",
  backgroundColor: Colors.white,
  borderBottomLeftRadius: "20px",
  borderBottomRightRadius: "20px",
};

export default CustomTable;
